module.exports = __webpack_public_path__ + "img/white_blueBackground_Text_small.4da4a68e.png";